export const CREATE_THEME = 'CREATE_THEME'
export const UPDATE_THEME = 'UPDATE_THEME'
export const DELETE_THEME = 'DELETE_THEME'
export const SEARCH_THEME = 'SEARCH_THEME'
export const SET_THEME_SEARCH_CRITERIA = 'SET_THEME_SEARCH_CRITERIA'
export const SET_THEME_DETAILS = 'SET_THEME_DETAILS'
